module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/plan_wayo_studio@2x-3013164c180ff21d91e3948a27c3f979.webp";